import { N11_02 } from "./N11_02";

export const N11_01 = {
  selectedValueColumn: "Title",
  selectedTitle: "Region",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Region",
        binding: {
          data: {
            columns: [
              {
                name: "Region",
                columnName: "RegionName",
                width: "450px",
                align: "left",
                sortable: true
              },
              {
                name: "Reached",
                columnName: "ReachedAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Total Accounts",
                columnName: "TotalAccounts",
                width: "180px",
                align: "center",
                sortable: true
              },
              {
                name: "Call Reach",
                columnName: "CallReach",
                width: "180px",
                align: "center",
                sortable: true,
                percent: true
              },
            ],
            title: "RegionName",
            endpoint: "SFE_N11.1",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
            ],
          },
          context: {
            point: {
              onClick: N11_02,
            },
          },
        },
      },
    },
  ],
};